import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.use(VueAxios, axios);

const baseUrl = process.env.VUE_APP_API_BASE_URL ?? 'http://localhost:4040';
const TOKEN = localStorage.getItem('AUTH_TOKEN');

const API = axios.create({
  baseURL: `${baseUrl}/api/v1`,
  headers: {
    Authorization: `Bearer ${TOKEN}`
  },
});

export default {
  login: params => API.post('/login', params),
  logout: () => API.get('/logout'),
};
